<template>
  <base-dialog-button :isOpen="dialogOpen" @closeDialog="toggleDialog" :size="mobileVersion ? 'fs' : 'lg-fix-h'">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.help_dialog_title')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
       <el-tabs tab-position="left" class="pt-2" style="height: inherit" ref="containertabs"  @tab-click="showBtnLicense">
        <el-tab-pane class="p-2 overflow-y-auto"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          >
           <span slot="label" class="flex items-center justify-start">
              <base-icon name="notes" size="xsm" class="mr-1"/> 
              <span v-if="!mobileVersion">{{$t('app.version_notes')}}</span>
              <span v-else>&nbsp;</span>
            </span>
          <div v-for="(version, index) in dataPatchNotes" :key="version.title" class="mb-8">
            <p class="font-medium text-lg mb-2">
              {{ version.title }} <span v-if="index === 0"> - {{$t('app.current_version')}}</span>
            </p>
            <p class="italic mb-2">
              {{ $d(Date.parse(version.date), 'long_date') }}
            </p>
            <div v-for="cambio in version.changes" :key="cambio.title" class="mb-4">
              <p class="font-medium mb-2">
                {{ cambio.title }}
              </p>
              <div v-for="descripcion in cambio.description" :key="descripcion">
                <p v-if="containsLinkTag(descripcion)" v-html="computeTag(descripcion,cambio.links)">
                </p>
                <p v-else>
                  • {{ descripcion }}
                </p>
              </div>
            </div>
          </div>
          </el-tab-pane>
        <el-tab-pane :disabled="!this.videoIds || this.videoIds.length === 0" class="p-2 overflow-y-auto container-youtube"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="videos" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('app.explainer_videos')}}</span>
              <span v-else>&nbsp;</span>
          </span>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div v-for="video in videoIds" :key="video.id">
              <p class="font-medium text-lg mb-2 truncate">
                {{ video.Titulo }}
              </p>
              <youtube :video-id="video.IdLink" ref="youtube" class="h-60 md:h-40 lg:h-60"/>
            </div>
          </div>
          </el-tab-pane>
        <el-tab-pane :disabled="false" class="p-2 overflow-y-auto"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
          >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="manual" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('app.use_manual')}}</span>
              <span v-else>&nbsp;</span>
          </span>
          <div>
            <p class="font-medium text-lg mb-2">
              {{$t('app.user_manual')}}
            </p>
            <div class="flex mb-2 items-center">
              <div class="w-full">
                <i18n path="app.user_manual_long" tag="p">
                  <span class="text-primary cursor-pointer hover:bg-primary-100 dark:hover:bg-darkblue-600 rounded" @click="openManualUsuario">{{$t('app.here')}}</span>
                </i18n>
              </div>
              <base-button-icon
                @click="downloadManualUsuario"
                size="xs"
                name="download"
                class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full ml-2 mr-4"
              />
            </div>
          </div>

          <div v-if="role === 3 || role === 8 || role === 7">
            <p class="font-medium text-lg mb-2">
              {{$t('app.distributor_manual')}}
            </p>
            <div class="flex mb-2 items-center">
              <div class="w-full">
                <i18n path="app.distributor_manual_long" tag="p">
                  <span class="text-primary cursor-pointer hover:bg-primary-100 dark:hover:bg-darkblue-600 rounded" @click="openManualDistribuidor">{{$t('app.here')}}</span>
                </i18n>
              </div>
              <base-button-icon
                @click="downloadManualDistribuidor"
                size="xs"
                name="download"
                class="bg-primary-100 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full ml-2 mr-4"
              />
            </div>
          </div>

          <a href="/files/EdasInvoiZE-Manual-v7.0.pdf" download class="hidden" ref="downloadManualBtn"/>
          <a href="/files/EdasInvoiZE-Manual-Distribuidor-v6.0.pdf" download class="hidden" ref="downloadManualDistribuidorBtn"/>
        </el-tab-pane>
        <el-tab-pane :disabled="false" class="p-2 overflow-y-auto"
          :style="mobileVersion ? 'height: 80vh;' : 'height: 52vh;'"
        >
          <span slot="label" class="flex items-center justify-start">
            <base-icon name="contract" size="xsm" class="mr-1"/> 
            <span v-if="!mobileVersion">{{$t('app.use_license')}}</span>
              <span v-else>&nbsp;</span>
          </span>
          <p class="font-bold text-lg mb-6">
            {{$t('app.license_dialog_title')}}
          </p>
          <LicenseContent/>
        </el-tab-pane>
      </el-tabs>
      <el-form
        ref="ruleForm"
      >
        <div class="lg:mb-2">
        </div>
      </el-form>
    </template>
    <template slot="footer">
      <div  class="flex-none flex items-center justify-between space-x-2 px-4 bg-white py-2 mt-auto dark:bg-darkblue-900">
        <base-button v-if="btnLicense" @click="downloadLicense" mode="secondary-phantom-blue" :text="$t('app.download')"/>
        <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.close')" />
          <a href="/files/EdasInvoiZE-Licencia-uso.pdf" download class="hidden" ref="downloadLicense"/>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import BaseDialogButton from './base/BaseDialogButton.vue'
import LicenseContent from '@/components/license/LicenseContent.vue'
import { PATCH_NOTES } from '@/config/dynamic/patch-notes-es'
import { getVideos } from '@/services/config/getVideos.js'

const localesMap = {
  es: () => import(/* webpackChunkName: "patch-notes-es" */ '@/config/dynamic/patch-notes-es'),
  'en-GB': () => import(/* webpackChunkName: "patch-notes-en" */ '@/config/dynamic/patch-notes-en-GB'),
  fr: () => import(/* webpackChunkName: "patch-notes-fr" */ '@/config/dynamic/patch-notes-fr'),
  de: () => import(/* webpackChunkName: "patch-notes-de" */ '@/config/dynamic/patch-notes-de'),
  ca: () => import(/* webpackChunkName: "patch-notes-ca" */ '@/config/dynamic/patch-notes-ca')
}

export default
{
  name: 'help-dialog',
  components: {
    BaseDialogButton,
    LicenseContent,
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    mobileVersion: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      if (value) {
        this.getVideos()
        window.$zoho.salesiq.floatbutton.visible('show')
        this.loadPatchNotes()
      } else {
        window.$zoho.salesiq.floatwindow.close()
        window.$zoho.salesiq.floatbutton.visible('hide')
      } 
    },
    '$i18n.locale' (newLocale, oldLocale) {
      if (newLocale && newLocale !== oldLocale) {
        this.loadPatchNotes(newLocale)
      }
    }
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      isLoadedData: false,
      // dataPatchNotes: PATCH_NOTES,
      patchNotesLang: '',
      dataPatchNotes: [],
      btnLicense: false,
      videoIds: [],
    }
  },
  created () {
  },
  mounted: async function () {
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    heigthVideos () {
      return this.mobileVersion ? 160 : 240
    },
    // player () {
    //   return this.$refs.youtube.player
    // },
    // heightViewTabs () {
    //   return this.$refs.containertabs?.clientHeight
    // }
  },
  methods: {
    getVideos: async function () {
      try {
        this.isLoadedData = false
        const response = await getVideos()
        if (response.blnError === true) {
          this.doFeedback(`${response.msgError} [${response.codError}]`)
        } else {
          for (let i = 0; i < response.listaVideos.length; i++) {
            response.listaVideos[i].id = i
          }
          this.videoIds = response.listaVideos
          this.isLoadedData = true
        }
      } catch (error) {
        this.doFeedback()
      } 
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    downloadManualUsuario () {
      this.$refs.downloadManualBtn.click()
    },
    downloadManualDistribuidor () {
      this.$refs.downloadManualDistribuidorBtn.click()
    },
    openManualUsuario () {
      window.open(window.location.origin + '/files/EdasInvoiZE-Manual-v7.0.pdf')
    },
    openManualDistribuidor () {
      window.open(window.location.origin + '/files/EdasInvoiZE-Manual-Distribuidor-v6.0.pdf')
    },
    // playVideo () {
    //   this.player.playVideo()
    // },
    downloadLicense () {
      this.$refs.downloadLicense.click()
    },
    containsLinkTag (descripcion) {
      return descripcion.includes('#link:')
    },
    computeTag (descripcion, links) {
      descripcion = `• ${descripcion}`
      const tags = []
      let finalIndex = 0
      let initIndex = descripcion.indexOf('#link:', finalIndex)
      let hasMoreTags = false
      if (initIndex !== -1) {
        do {
          initIndex = descripcion.indexOf('#link:', finalIndex)
          finalIndex = descripcion.indexOf('#', initIndex+1)
          tags.push(descripcion.substring(initIndex, finalIndex+1))
          hasMoreTags = descripcion.indexOf('#link:', finalIndex) !== -1
        } while (hasMoreTags)

        tags.forEach(tag => {
          const searchedLink = links.filter(filter => filter.tag === tag.split(':')[1].replace('#', ''))[0]
          if (searchedLink) {
            const defaultLink = `<a href= "${searchedLink.url}" style="text-decoration: underline" target="_blank">${searchedLink.linkName}</a>`
            descripcion = descripcion.replace(tag, defaultLink)
          }
        })
      }
      return descripcion
    },
    showBtnLicense (tab, event) {
      if (parseInt(tab.index) === 3) {
        this.btnLicense = true
      } else {
        this.btnLicense = false
      }
    },
    async loadPatchNotes (locale) {
      const currentLocale = locale || this.$i18n.locale || 'es'
      if (this.dialogOpen && this.patchNotesLang !== currentLocale) {
        try {
          const loader = localesMap[currentLocale] || localesMap.es // Fallback al español
          this.dataPatchNotes = (await loader()).PATCH_NOTES
          this.patchNotesLang = currentLocale
        } catch (error) {
          console.error('Error loading patch notes for locale:', currentLocale, error)
          this.dataPatchNotes = PATCH_NOTES
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
